module.exports = __webpack_public_path__ + "static/media/arrow-downDark.654b1a16.svg";